import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Trophy } from 'lucide-react';
import { ProcessedLoan } from '../data/mockLoans';
interface QueueEmptyStateProps {
  history: ProcessedLoan[];
}
export function QueueEmptyState({
  history
}: QueueEmptyStateProps) {
  const callsMade = history.filter(h => h.action === 'called').length;
  const snoozed = history.filter(h => h.action === 'snoozed').length;
  const notesLeft = history.filter(h => h.action === 'noted').length;
  return <div className="flex-1 flex items-center justify-center bg-stone-50 p-8" data-id="element-122">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-stone-200 p-8 text-center" data-id="element-123">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" style={{
        backgroundColor: 'rgba(197, 165, 90, 0.15)'
      }} data-id="element-124">
          <Trophy className="w-10 h-10" style={{
          color: '#C5A55A'
        }} data-id="element-125" />
        </div>

        <h1 className="text-2xl font-bold text-stone-900 mb-2" data-id="element-126">
          Queue Complete!
        </h1>
        <p className="text-stone-600 mb-8" data-id="element-127">
          Great job. You've processed all the loans in your list for this
          session.
        </p>

        <div className="grid grid-cols-3 gap-4 mb-8" data-id="element-128">
          <div className="bg-stone-50 rounded-xl p-4 border border-stone-100" data-id="element-129">
            <div className="text-2xl font-bold text-stone-900" data-id="element-130">{callsMade}</div>
            <div className="text-xs font-medium text-stone-500 uppercase tracking-wider mt-1" data-id="element-131">
              Calls
            </div>
          </div>
          <div className="bg-stone-50 rounded-xl p-4 border border-stone-100" data-id="element-132">
            <div className="text-2xl font-bold text-stone-900" data-id="element-133">{notesLeft}</div>
            <div className="text-xs font-medium text-stone-500 uppercase tracking-wider mt-1" data-id="element-134">
              Notes
            </div>
          </div>
          <div className="bg-stone-50 rounded-xl p-4 border border-stone-100" data-id="element-135">
            <div className="text-2xl font-bold text-stone-900" data-id="element-136">{snoozed}</div>
            <div className="text-xs font-medium text-stone-500 uppercase tracking-wider mt-1" data-id="element-137">
              Snoozed
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 font-medium py-3 px-4 rounded-lg" style={{
        color: '#C5A55A',
        backgroundColor: 'rgba(197, 165, 90, 0.1)'
      }} data-id="element-138">
          <CheckCircle className="w-5 h-5" data-id="element-139" />
          All caught up
        </div>
      </motion.div>
    </div>;
}